export default __webpack_public_path__ + "static/media/(33).2773a519.jpg";